export default {
  loading: false,
  error: null,
  message: null,
  
  settings: null,
  settingsLoaded: false,
  oauthUrl: null,
  amazonState: null,
  contact: {},
  contactLoading: false,
  policyLinks: [],
  policyLinksLoading: false,
  branding: {},
  brandingLoading: false,
  checkout: {},
  checkoutLoading: false,
  allow_pay_later: false,
  contact_name_required: false,
  contact_phone_required: false,
  reseller_markup: null,
  markupLoading: false,
  basicSettings: {},
  reseller_markup: null
}